import { useMutation } from "@tanstack/react-query";
import { vacancyService } from "@/services/vacancyService";
import { vacancyQueryKeys } from "@/hooks/queries/usevacancy";

// Define mutation keys for vacancy-related mutations.
export const vacancyMutationKeys = {
    all: ["vacancy"],
    list: () => [...vacancyMutationKeys.all, "list"],
    details: (id) => [...vacancyMutationKeys.all, "detail", id],
    create: () => [...vacancyQueryKeys.all, "create"],
    update: () => [...vacancyQueryKeys.all, "update"],
};

// create vacancy
export const useCreateVacancy = () => {
    return useMutation({
        mutationKey: vacancyMutationKeys.create(),
        mutationFn: (vacancyData) => vacancyService.createVacancy(vacancyData),
    });
}

// update vacancy
export const useUpdateVacancy = () => {
    return useMutation({
        mutationKey: vacancyMutationKeys.update(),
        mutationFn: ({ vacancyId, vacancyData }) =>
            vacancyService.updateVacancy(vacancyId, vacancyData),
    });
}

// delete vacancy
export const useDeleteVacancy = () => {
    return useMutation({
        mutationKey: vacancyMutationKeys.delete(),
        mutationFn: (vacancyId) => vacancyService.deleteVacancy(vacancyId),
    });
}

